
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    right: {
      type: Boolean,
      default: false
    }
  }
});
